import { render, staticRenderFns } from "./FormView.vue?vue&type=template&id=0980f0d8&scoped=true"
import script from "./FormView.vue?vue&type=script&lang=js"
export * from "./FormView.vue?vue&type=script&lang=js"
import style0 from "@/styles/components/FormView/FormView.less?vue&type=style&index=0&id=0980f0d8&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0980f0d8",
  null
  
)

export default component.exports